import React, { Component } from 'react';
import $ from '@alife/alpha-jquery/jquery';
import AlitalkRfq from '@alife/alpha-alitalk/alitalk-rfq';
import CallUsBtn from './call-us';
import ContactSupplierBtn from './contact-supplier';

export default class SourcingAction extends Component {
  constructor(props) {
    super(props);
    this.alitalk = React.createRef();
  }

  componentDidMount() {
    const { i18n } = this.props;
    const STATUS_CLASS = {
      LEISURE: {
        title: i18n['common.atm.leisure.title'],
        text: i18n['common.atm.leisure.text'],
      },
      LEAVE: {
        title: i18n['common.atm.offline.title'],
        text: i18n['common.atm.leave.text'],
      },
      OFFLINE: {
        title: i18n['common.atm.offline.title'],
        text: i18n['common.atm.offline.text'],
      },
      BUSY: {
        title: i18n['common.atm.offline.title'],
        text: i18n['common.atm.busy.text'],
      },
    };
    AlitalkRfq.renderList(this.alitalk.current, {
      renderCallback(params) {
        const elAlitalk = $(this.element);
        const texts = STATUS_CLASS[params.status] || {};

        elAlitalk.addClass(params.class);
        elAlitalk
          .find('[data-role=atm-text]')
          .attr('title', texts.title || params.title)
          .html(texts.text || params.text);
      },
    });
  }

  render() {
    const {
      i18n,
      baoAccountIsService,
      baoAccountIsDisplayAssurance,
      productOwnMemberAlitalkEncryptId,
      productId,
      contactEncryptId,
      contactName,
      photoUrl,
      productEncryptId,
      umidToken,
      hasVideoChat,
      csTestVersion,
      productIsHang,
    } = this.props;
    const isXb = baoAccountIsService ? 1 : 0;
    const isDa = baoAccountIsDisplayAssurance ? 1 : 0;

    const csUrl = `//message.alibaba.com/msgsend/contact.htm?action=contact_action&domain=1&id=${productId}&id_f=${productEncryptId}&mloca=main_en_detail&tracelog=tracedetailfeedback&umidToken=${umidToken}`;
    const isAlitalkNew = csTestVersion === 'VA';
    return (
      <div
        className="widget-supplier-card company-card-integrated company-card-integrated-lite company-card-integrated-lite-b module-detail-actions"
        style={{ background: '#fff', width: '260px' }}
      >
        <span className="card-action-tip">
          {i18n['supplierCard.action.tip']}
        </span>

        <ContactSupplierBtn
          className="ui2-button ui2-button-primary ui2-button-large card-action-button-contact-supplier"
          domdot={`id:3301,ext:'is_xinbao_product=${isXb}|is_display_assurance=${isDa}'`}
          href={csUrl}
          i18n={i18n}
          contactName={contactName}
          productId={productId}
          productOwnMemberAlitalkEncryptId={productOwnMemberAlitalkEncryptId}
          contactEncryptId={contactEncryptId}
          photoUrl={photoUrl}
          isNewVersion={isAlitalkNew}
          productIsHang={productIsHang}
        />

        {hasVideoChat ? (
          <CallUsBtn
            productOwnMemberAlitalkEncryptId={productOwnMemberAlitalkEncryptId}
            productId={productId}
            i18n={i18n}
            contactEncryptId={contactEncryptId}
            contactName={contactName}
            photoUrl={photoUrl}
          />
        ) : null}

        <div className="alitalk-container">
          <a
            data-domdot={`id:3302,ext:'is_xinbao_product=${isXb}|is_display_assurance=${isDa}'`}
            data-role="alitalk"
            className="atm link-default"
            data-uid={productOwnMemberAlitalkEncryptId}
            data-pid={productId}
            data-contactid={contactEncryptId}
            data-biz-type="1"
            data-contactname={contactName}
            data-contactimg={photoUrl}
            data-productid={productId}
            data-biz-id={productId}
            data-is-new-webatm="true"
            data-scene-type="detail"
            ref={this.alitalk}
          >
            <i data-role="atm-icon" className="ui2-icon ui2-icon-alitalk" />
            <span data-role="atm-text">
              {i18n['mainAction_sub_operate_atm']}
            </span>
          </a>
        </div>
      </div>
    );
  }
}
